<template>
  <div class="detail-container">
    <div class="permit-detail-box columns is-multiline is-centered is-12">
      <div class="column is-9">
        <div class="permit-title has-text-weight-semibold">{{ this.$store.state.detailPage.permitDescription }}</div>
        <div class="permit-number is-size-2">{{ this.$store.state.detailPage.permitNumber }}</div>
        <div
          class="permit-address has-text-weight-bold"
        >
         L&I District:  {{this.$store.state.searchResults.li_district}}
        </div>
        <div
          class="permit-address has-text-weight-bold"
        >
          OPA Account #:  {{this.$store.state.detailPage.opa_account_num}}
        </div>
        <div
          class="permit-address"
          v-for="item in this.$store.state.detailPage.permitAddress"
          :key="item"
        >
          <div class="multi-cell">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="permit-date"><b>ISSUED</b> {{ " " + formattedPermitDate }} </div>
      </div>
    </div>
    <div class="detail-table-container columns is-multiline is-centered is-12">
      <v-client-table
        class="table-light no-header column is-12"
        :data="tableData"
        :columns="columns"
        :options="options"
      >
        <template
          slot="name"
          slot-scope="{row}"
          class="multi-cell"
        >

        <!-- single-line cell template -->
        <div 
          v-if="(typeof row.name === 'string') && (row.id !== 'Zoning documents')"
        >
          <div
            class="multi-cell"
            :class="extraPaddingRow(row.id)"
          >
            {{ row.name }}
          </div>
        </div>

        <!-- multi-line cell template -->
        <div
          v-if="(typeof row.name === 'object') && (row.id !== 'Zoning documents')"
          :class="extraPaddingRow(row.id)"
        >
          <div
            v-for="item in row.name"
            :key="item.id"
          >
            <div
              class="multi-cell"
            >
              {{ item }}
            </div>
          </div>
        </div>

        <!-- zoning cell template -->
        <div v-if="row.id === 'Zoning documents'">
          <div v-if="row.name.length === 0"
          >
            No zoning documents
          </div>
          <div
            v-for="item in row.name"
            :key="item.id"
            class="multi-cell zoning-border"
          >
            <div class="zoning-left">
              <div class="zoning-top">
                {{ item.date }}
              </div>
              <div class="zoning-bottom">
                <div class="zoning-small">
                  <span>PAGES: <b>{{ item.pages }}</b></span>
                </div>
                <div class="zoning-small">
                  <span>FILE-SIZE: <b>{{ item.fileSize }}</b></span>
                </div>
              </div>
            </div>
            <div class="zoning-right">
              <a 
                class="is-link is-small"
                target="_blank"
                :href="getZoningURL(item) + item.pdfName"
              >
                  {{ item.pdfName }}
                  <i class="fa fa-external-link" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>

        </template>
      </v-client-table>
    </div>
  </div>
</template>

<script>

import moment from 'moment';

export default {
  name: 'PermitDetail',
  data() {
    return {
      detailInfo: this.$store.state.detailPage,
      columns: ['id', 'name'],
      options: {
        filterable: false,
        sortable: [],
        highlightMatches: false,
        pagination: {
          show: false,
          virtual: false,
        },
        perPage: 100,

        columnsClasses: {
          id: 'table-id has-text-weight-bold',
          name: 'table-name',
        },
      },
    }
  },
  destroyed() {
    this.$store.commit('closeDetail');
  },
  computed: {
    formattedPermitDate(){
      return moment(this.detailInfo.permitDate).isValid() ? moment(this.detailInfo.permitDate).format('MM/DD/yyyy') : "Not Available"
    },
    getMailingAddress(){
      if(this.$store.state.mailingAddress){
        let mailingData = this.$store.state.mailingAddress;
        let mailingArray = [];
        if(mailingData.mailing_address_1){
          mailingArray.push.apply(mailingArray, [mailingData.mailing_address_1, mailingData.mailing_address_2])
        } else {
          mailingArray.push(mailingData.mailing_street)
        }
        mailingArray.push(mailingData.mailing_city_state + " " + mailingData.mailing_zip)
        return mailingArray
      } else {
        return []
      }
    },
    zoningDocs() {
      let docs = this.$store.state.zoningDocs
      if (docs && docs.length > 0 ) {
        let docArray = [];
        docs.forEach( a => {
          let docObj = new Object();
          docObj.date = moment(a.scan_date).format('MMM DD, yyyy');
          docObj.pages = a.num_pages;
          docObj.pdfName = a.doc_id + ".pdf"

          let getSize =function filterByValue(array, string) {
            // console.log(array, string);
            return array.forEach(o => {
              // console.log(o, o.name, string);
              o.name === string ? docObj.fileSize = o.size + "mb" : "";
            });
          }
          getSize(this.$store.state.zoningDocsFileSizes, docObj.pdfName );
          docArray.push(docObj)
        });
        // console.log(docArray)
        return docArray
      }
      return []
    },
    tableData(){
      let tableInfo = [
          { id: "L&I district",
            name: this.$store.state.searchResults.li_district
          },
          // { id: "Owner name",
          //   name: this.detailInfo.permitOwnerName
          // },
          // { id: "Owner mailing address",
          //   name: this.getMailingAddress
          // },
          { id: "Permit number",
            name: this.detailInfo.permitNumber
          },
          { id: "Permit type",
            name: this.detailInfo.permitDescription + " (" + this.detailInfo.permitType + ")"
          },
          { id: "Type of work",
            name: [this.detailInfo.permitTypeOfWork, this.detailInfo.permitScopeOfWork]
          },
          { id: "Permit status",
            name: this.detailInfo.permitStatus
          },
          { id: "Date issued",
            name: moment(this.detailInfo.permitIssuedDate).isValid() ? moment(this.detailInfo.permitIssuedDate).format('MMM DD, yyyy') : "Not Available",
          },
          { id: "Zoning documents",
            name: this.zoningDocs
          },
          { id: "Contractor",
            name: this.detailInfo.permitContractorname ? [ this.detailInfo.permitContractorname,
                    ...this.detailInfo.permitContractorAddress] : "No Contractor Listed"
          },
          // { id: "Subcontractor",
          //   name: this.detailInfo.permitSubContractorname ? [ this.detailInfo.permitSubContractorname,
          //            ...this.detailInfo.permitSubContractorAddress ] : "No Subcontractor Listed"
          // },
      ]
      return tableInfo;
    }
  },
  methods: {
    clickBackButton(){
      this.$store.commit('closeDetail');
    },
    extraPaddingRow(id){
      // console.log("row class", id);
      if(id === 'Owner mailing address' || id === 'Date issued'){
        return "extra-row-padding"
      }
      return
    },
    getZoningURL(item){
      let eclipseCheck = this.$store.state.zoningDocs.filter(obj => obj.doc_id + ".pdf" === item.pdfName);
      if(eclipseCheck[0] &&eclipseCheck[0].eclipse) {
        return "https://s3.amazonaws.com/eclipse-docs-pdfs/zoning/"
      }
      return "https://s3.amazonaws.com/lni-zoning-pdfs/"
    }
  },
}
</script>
<style lang="scss">

.columns:last-child {
  margin-bottom: .75rem !important;
}

.detail-container {
  margin-top: 4rem;
  background-color: white;
  margin: auto;
}

.detail-button {
  margin-top: 20px;
}

.no-header th {
  display: none !important;
}

//  CSS for grey header-box in permit detail page
.detail-container .permit-detail-box {
  background-color: $ben-franklin-blue-light;
  margin: 0;
  padding: 15px 5px 15px 25px;
  clear: both;
  & .column {
    padding: 0;
  }
  .permit-title {
    text-transform: uppercase;
  }
  .permit-number {
    padding: 5px 0 15px 0;
  }
}

.table-id.has-text-weight-bold {
  width: 35%;
}

div.is-pulled-right.VueTables__limit {
   display: none;
}

.extra-row-padding {
  padding-bottom: 1rem;
}

// CSS for the Zoning Cell elements from scoped-slot
.zoning-border {
  &:not(:last-child){
    border-bottom: 1px black solid;
    padding-bottom: 10px;
  }
  width: 100%;
  height: 100%;
  clear: both;
  margin: 5px 0;
  display: flow-root;
  position: relative;
  .zoning-left {
    width: 50%;
    float: left;
    display: block;
  }
  .zoning-right {
    position: absolute;
    padding: 10px;
    right: 0;
  }
  .zoning-bottom {
    font-size: small;
    display: flex;
    .zoning-small {
      display: inline-grid;
      flex-grow: 1;
    }
  }
  }

</style>